import { css } from 'emotion';
import React, { Component } from 'react';
import Field from 'redux-form/lib/Field';
import Alert from 'react-bootstrap/lib/Alert';
import FieldFormGroup from '../FieldFormGroup';
import styles from './styles.sass';
import { Button } from '../../shared/Button/NewButton';

class RequestResetPassword extends Component {
  constructor(props, context) {
    super(props, context);
    this.handleClickLogIn = this.handleClickLogIn.bind(this);
  }

  handleClickLogIn(evt) {
    const { clickLogIn } = this.props;
    evt.preventDefault();
    clickLogIn();
  }

  render() {
    const { error, handleSubmit, submitting } = this.props;
    return (
      <div>
        <p className="text-center">
          Type your email below, and we’ll email you a link to reset your
          password.
        </p>
        <form
          onSubmit={handleSubmit}
          id="form1"
          className={css`
            text-align: center;
          `}
        >
          {error && <Alert bsStyle="danger">{error}</Alert>}
          <div>
            <Field
              name="email"
              placeholder="Email"
              component={FieldFormGroup}
              type="email"
            />
          </div>
          <Button
            color="purple"
            type="submit"
            isDisabled={submitting}
            className={css`
              width: 200px;
            `}
          >
            Reset Password
          </Button>
        </form>
        <p className={`text-center ${styles.loginFooter}`}>
          <a onClick={this.handleClickLogIn}>Log in</a>
        </p>
      </div>
    );
  }
}

export default RequestResetPassword;
